import React from 'react';
import {
  Placeholder,
  ComponentRendering,
  ComponentParams,
  ComponentFactory,
} from '@sitecore-jss/sitecore-jss-react';
import { Container, Grid } from '@material-ui/core';
import './index.scss';

export type SnowDragonComponentProps = {
  componentFactory: ComponentFactory;
  rendering: ComponentRendering;
  params: ComponentParams;
};

const OneColumnContentRowWithMargins = (props: SnowDragonComponentProps): JSX.Element => {
  return (
    <>
      <Container maxWidth="lg">
        <Grid className="one-column-content-row-with-margins" container>
          <Grid item xs={12}>
            <div>
              <Placeholder name="column_one" rendering={props.rendering} />
            </div>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default OneColumnContentRowWithMargins;
